/*
 * UI/UX改善 #6: スクロールプログレスバー
 * ヘッダー下にページ進捗バーを表示
 * eightone赤 (#E03030) で統一
 */

import { useState, useEffect } from "react";
import { motion, useSpring } from "framer-motion";

export function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  const smoothProgress = useSpring(progress, { stiffness: 100, damping: 30 });

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0) {
        setProgress(scrollTop / docHeight);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="fixed top-16 lg:top-20 left-0 right-0 z-50 h-[2px] bg-transparent pointer-events-none">
      <motion.div
        className="h-full bg-[#E03030] origin-left"
        style={{ scaleX: smoothProgress }}
      />
    </div>
  );
}
